import { render } from "./Consultation.vue?vue&type=template&id=2f5759d4&scoped=true"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"

import "./Consultation.vue?vue&type=style&index=0&id=2f5759d4&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5759d4"]])

export default __exports__